import React, { memo } from 'react';
import { IconValidationInvalid, TextInput } from '@adc/parallax-component-library';
const Input = memo(({ isInvalid = false, label = '', errorMessage, placeholder = '', value, onBlur, onChangeText, disabled, testID, inputMode, onFocus, maxLength, }) => {
    const showsErrorMessage = isInvalid && errorMessage;
    return (React.createElement(TextInput, { inputMode: inputMode, "aria-label": label, label: label, placeholder: placeholder, onFocus: onFocus, onBlur: onBlur, error: isInvalid, supportingText: showsErrorMessage ? errorMessage : undefined, supportingIconConfig: showsErrorMessage
            ? {
                icon: React.createElement(IconValidationInvalid, { testID: `${testID}-icon` }),
                color: '$support.danger.surfaceOnColorAlt',
            }
            : undefined, onChangeText: onChangeText, value: value, testID: testID, disabled: disabled, maxLength: maxLength }));
});
Input.displayName = 'Input';
export { Input };
